import env from './env.js';
import routes from './routes.js';

let tenants = [];

try {
    tenants = JSON.parse(env('TENANTS'));
    /* eslint-disable no-empty */
} catch (e) {}


export default {
    tenants,
    baseUrls: {
        api: env('API_URL'),
        authServer: env('AUTH_SERVER_URL') || 'https://auth-server.ngs.test',
        deliver: env('DELIVER_URL') || 'https://deliver.ngs.test',
        diagnostic: env('DIAGNOSTIC_URL') || 'https://diagnostic.ngs.test',
        proctoring: env('PROCTORING_URL') || 'https://pr-lti-gateway.ngs.test',
        grading: env('GRADING_URL') || 'http://ms-be.ngs.test',
        simpleReportsApi: env('SIMPLE_REPORTS_API_URL') || 'https://sr-be.ngs.test',
        aiWebSocket: env('WEBSOCKET_AI_PUBLIC_URL') || 'https://tao-ai-ws.ngs.test',
        aiApi: env('AI_API_URL') || 'https://tao-ai-api.ngs.test',
        deliveryPreview: env('DELIVERY_PREVIEW_URL') || 'https://test-runner-sandbox.ngs.test',
        studio: env('STUDIO_URL') || 'https://studio.ngs.test',
        portal: env('STATIC_URL'),
        jsreport: env('JSREPORT_URL') || 'http://localhost:5488',
        wsTaskOrchestratorURL: env('WS_TASK_ORCHESTRATOR_URL')
    },
    routes,
    endpoints: {
        batteries: '/api/v1/batteries',
        battery: '/api/v1/batteries/:id',
        delivery: '/api/v1/deliveries/:deliveryId',
        editDelivery: '/test-editor/',
        entitiesList: '/api/v1/data/entity/list',
        entity: '/api/v1/data/entity/:entityId/detail',
        entityData: '/api/v1/data/entity/:entityId/data',
        entityTableData: '/api/v1/data/entity/:entityId/table',
        exportResults: '/api/v1/sessions/:sessionId/results',
        exportEnrolments: '/api/v1/sessions/enrolments',
        generateAIDelivery: '/api/v1/ai/generate',
        getOrganizationTree: '/api/v1/hierarchies',
        group: '/api/v1/groups/:groupId',
        groups: '/api/v1/groups',
        'groups.users': '/api/v1/groups/:groupId/users',
        hierarchy: '/api/v1/hierarchies/:id',
        hierarchyActivate: '/api/v1/hierarchy-configs/activate',
        hierarchyAddChild: '/api/v1/hierarchies/add-child',
        hierarchyMigrateEntities: '/api/v1/hierarchies/migrate',
        importData: '/api/v1/import-data/csv',
        importDataAsync: '/api/v1/import-data/async-csv',
        downloadCsvTemplates: '/api/v1/import-data/download-csv-templates',
        infoAIDelivery: '/api/v1/ai/info',
        launchAuthoring: '/api/v1/lti/launch-authoring',
        launchDeliveryExecution: '/api/v1/lti/launch-delivery-execution/:sessionId',
        launchPublicDeliveryExecution: '/api/v1/lti/launch-public-delivery-execution/:sessionId',
        launchGrader: '/api/v1/lti/launch-grader/:deliveryExecutionId',
        launchProctoringMonitoring: '/api/v1/lti/launch-proctoring-monitoring/:sessionId',
        generatePreviewDeliveryLink: '/api/v1/lti/preview-delivery-link/:deliveryId',
        login: '/v1/oauth2/tokens', // Auth Server's endpoint
        ssoLogin: '/v1/sso/login/:clientId/:providerId', // Auth Server's endpoint
        lookup: '/api/v1/data/lookup/:entityId',
        previewAIDelivery: '/',
        previewDeliveryExecution: '/api/v1/lti/preview-delivery-execution/:deliveryId',
        publishAIDelivery: '/api/v1/ai/publish',
        publishClonedDelivery: '/api/v1/deliveries/:id/publish-clone',
        publishDelivery: '/api/v1/publication/publish',
        refreshToken: '/v1/oauth2/tokens', // Auth Server's endpoint
        renderReport: '/api/report',
        reportsTranslations: '/api/v1/configuration/:tenantId/reports-translations/:locale',
        reviewDeliveryExecution: '/api/v1/lti/review-delivery-execution/:deliveryExecutionId/:itemId?',
        roles: '/api/v1/users/user/roles',
        searchAssets: '/api/v1/assets/search',
        searchBatteries: '/api/v1/batteries/search',
        searchDeliveries: '/api/v1/deliveries/search',
        searchGroups: '/api/v1/groups/search',
        searchSessions: '/api/v1/sessions/search',
        searchSessionUsers: '/api/v1/sessions/:sessionId/users/search',
        searchTags: '/api/v1/tags/search',
        searchUsers: '/api/v1/users/search',
        searchView: '/api/v1/data/views/:viewId',
        searchViews: '/api/v1/data/views',
        session: '/api/v1/sessions/:sessionId',
        sessionUser: '/api/v1/sessions/:sessionId/users/:userSessionId',
        sessions: '/api/v1/sessions',
        'simpleReports.getReport': '/api/v1/report/slug/:slug',
        'simpleReports.getReports': '/api/v1/report',
        'simpleReports.getWidgetData': '/api/v1/widget/data/:id',
        studentSessions: '/api/v1/sessions/user',
        publicSessions: '/api/v1/sessions/public/:subdomain',
        subdomain: '/v1/subdomains/:type/:subdomain', // Auth Server's endpoint
        tags: '/api/v1/tags',
        tenantConfiguration: '/api/v1/configuration/:subdomain',
        updateAIDelivery: '/api/v1/ai/update',
        uploadAsset: '/api/v1/assets/upload',
        user: '/api/v1/users/:login',
        'user.groups': '/api/v1/users/:login/groups',
        users: '/api/v1/users',
        view: '/api/v1/data/view',
        waitingAIDelivery: '/website/waiting',
        activityLog: '/api/v1/activity-log',
        emailVerification: '/api/v1/emails/verify',
        emailSubscriptionsCancel: '/api/v1/emails/subscriptions/cancel',
        emailVerificationSend: '/api/v1/emails/:login/verification/send',
        notificationsOptions: '/api/v1/notifications-options',
    }
};
